import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { X } from "lucide-react";

const CONSENT_KEY = "cardoso_cookie_consent";

export default function CookieConsent() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem(CONSENT_KEY);
    if (!consent) {
      const timer = setTimeout(() => setVisible(true), 1500);
      return () => clearTimeout(timer);
    }
    if (consent === "accepted") {
      enableAnalytics();
    }
  }, []);

  const enableAnalytics = () => {
    // Enable GA4 if gtag exists
    if (window.gtag) {
      window.gtag("consent", "update", {
        analytics_storage: "granted",
      });
    }
  };

  const accept = () => {
    localStorage.setItem(CONSENT_KEY, "accepted");
    enableAnalytics();
    setVisible(false);
  };

  const decline = () => {
    localStorage.setItem(CONSENT_KEY, "declined");
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      data-testid="cookie-consent-banner"
      className="fixed bottom-0 left-0 right-0 z-[60] p-4 md:p-6 animate-fade-in-up"
    >
      <div className="max-w-4xl mx-auto bg-white border border-slate-200 shadow-2xl p-6 md:p-8">
        <div className="flex items-start justify-between gap-4 mb-4">
          <h3 className="font-['Barlow_Condensed'] text-lg font-bold uppercase text-[#0F172A]">
            Cookies
          </h3>
          <button
            onClick={decline}
            data-testid="cookie-close-btn"
            className="text-slate-400 hover:text-slate-600 transition-colors"
          >
            <X className="w-5 h-5" />
          </button>
        </div>
        <p className="text-slate-600 text-sm leading-relaxed mb-6">
          Wij gebruiken cookies om uw ervaring op onze website te verbeteren en om websiteverkeer 
          te analyseren. Door op "Accepteren" te klikken gaat u akkoord met het gebruik van 
          analytische cookies. Lees meer in ons{" "}
          <Link to="/privacy" data-testid="cookie-privacy-link" className="text-[#005F5F] font-medium underline hover:text-[#C5A059] transition-colors">
            privacybeleid
          </Link>.
        </p>
        <div className="flex flex-wrap gap-3">
          <button
            onClick={accept}
            data-testid="cookie-accept-btn"
            className="bg-[#C5A059] hover:bg-[#005F5F] text-white font-bold uppercase tracking-wider px-6 py-3 text-xs transition-all duration-300"
          >
            Accepteren
          </button>
          <button
            onClick={decline}
            data-testid="cookie-decline-btn"
            className="bg-transparent border-2 border-slate-300 text-slate-600 hover:border-[#005F5F] hover:text-[#005F5F] font-bold uppercase tracking-wider px-6 py-3 text-xs transition-all duration-300"
          >
            Alleen noodzakelijk
          </button>
        </div>
      </div>
    </div>
  );
}
